/* Core & libraries */
import * as React from "react";
import { useTheme } from "react-jss";
import "react-toggle/style.css"

/* Helpers, constants, custom methods, internal libraries */
/* Components */
/* Styles */
import styles from "./styles.js"

const UCCheckbox = props => {
  const { checked, onChange, label, icon, className, labelClass, disabled } = props;

  const theme = useTheme();
  const classes = styles({ theme });

  return (
    <label className={classes.checkboxWrapper}>
      <input type="checkbox" checked={checked} onChange={onChange} disabled={disabled} />
      <div className={`${checked ? (disabled ? classes.checkedDisabled : classes.checked) : ""} ${classes.checkbox} ${className} ${disabled ? classes.disabled : ""}`}></div>
      {
        label && <span className={`${disabled ? classes.disabledLabel : classes.label} ${labelClass}`}>{label}</span>
      }
      {
        icon && <span className={classes.icon}>{icon}</span>
      }
    </label>
  )
}

export default UCCheckbox;
